import './financing-step.scss';

import { useAppSelector } from '@/store';

import { BitrixDocuments, LoadDocuments } from './entities';
import { InfoAlert } from './ui';
import { CurrentBankView, CurrentLeasingView, SideInfo } from './widgets';

export const FinancingStep: React.FC = () => {
  const { orderApp } = useAppSelector((state) => state.newOrder);
  const { selectedBank, selectedLeasing } = useAppSelector(
    (state) => state.financingStep
  );

  const shouldShowBitrixDocuments =
    selectedBank?.bank.name === 'eu_bank_v2' && // Возможны дополнения для других банков
    selectedBank?.status.code === 'waiting_for_docs_confirmation';

  return (
    <div className="financing-step">
      <div className="financing-step__wrapper">
        {shouldShowBitrixDocuments && <BitrixDocuments />}
        <div className="financing-step__content">
          {orderApp?.sentTo !== 'banks' && selectedLeasing ? (
            <>
              <div className="financing-step__header">
                <h2 className="financing-step__title">Документы</h2>
              </div>

              <div className="financing-step__bank-view">
                <CurrentLeasingView />
              </div>
            </>
          ) : (
            <>
              <div className="financing-step__header">
                <h2 className="financing-step__title">Документы</h2>
                <LoadDocuments />
              </div>

              <div className="financing-step__bank-view">
                <CurrentBankView />
              </div>
            </>
          )}
        </div>

        <InfoAlert />
      </div>

      <div className="financing-step__side">
        <SideInfo />
      </div>
    </div>
  );
};
